import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NetworkCheckIcon(props: IconProps) {
    return <Icon {...props} iconKey={"network_check"}/>
}
